import React, { useEffect, useState } from "react";
import { Modal } from "../../../components/modal";
import {
  CONFIRM_ACCEPT_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  OTHER_SUB_ITEMS_ACCOUNTING_HINT,
  TEAM_LIST_HINT
} from "../../../constants/otherTexts";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { TeamAction } from "../../../actions";
import { Box, Hint } from "../style";
import FloatLabelInput from "../../../components/floatLableInput";
import { teamNameLength } from "../../../constants/maxLenghtAtrribute";
import TeamsSection from "./components/teams";
import { isEmpty } from "lodash";
import SingleAccountingCode from "../../../projectSpecificComponents/singleAccountingCode";
import { getTypeObjects } from "../../../constants/accounting";

const Form = props => {
  const {
    modalData,
    modalStatus,
    closeModal,
    processing,
    add,
    edit,
    change,
    handleSubmit,
    initialize
  } = props;
  const [allAccessibleTeams, setAllAccessibleTeams] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (!isEmpty(modalData)) {
      const editMode = modalData.id !== undefined;
      if (!editMode) {
        const allTeams = modalData.project && modalData.project.teams;
        setAllAccessibleTeams(allTeams);
        const selectedTeamIds = allTeams.map(team => team.id);
        initialize({ ...modalData, team_ids: selectedTeamIds });
      } else {
        console.log(modalData);
        initialize(modalData);
      }
      setIsEdit(editMode);
    }
  }, [modalData]);

  const submit = values => {
    let errors = {};
    if (!values.name) {
      errors.name = "وارد کردن نام تیم الزامی است";
    }

    if (Object.keys(errors).length <= 0) {
      const { project, ...others } = values;
      const finalValues = {
        ...others,
        single_accounting_code:
          values.single_accounting_code && values.single_accounting_code.code
      };
      if (isEdit) {
        edit(modalData.id, finalValues);
      } else {
        if (modalData && modalData.project) {
          add(modalData.project.id, finalValues);
        }
      }
    } else {
      throw new SubmissionError(errors);
    }
  };
  return (
    <Modal
      show={modalStatus}
      height={isEdit ? "auto" : undefined}
      closeHandler={closeModal}
      width="330px"
      loading={processing}
      header={{
        title: isEdit ? "ویرایش تیم تنخواه‌داری" : "افزودن تیم تنخواه‌داری"
      }}
      footer={{
        buttons: [
          {
            buttonType: "primary",
            buttonText: CONFIRM_ACCEPT_BUTTON_TEXT,
            form: "teamForm",
            type: "submit",
            useLoading: true
          },
          {
            buttonType: "secondary",
            clickHandler: closeModal,
            buttonText: CONFIRM_REJECT_BUTTON_TEXT
          }
        ]
      }}
    >
      <Box onSubmit={handleSubmit(submit)} id="teamForm">
        <Hint maxWidth={400}>{TEAM_LIST_HINT}</Hint>
        <Field
          name="name"
          component={FloatLabelInput}
          label={`نام تیم تنخواه‌داری`}
          disabled={processing}
          maxLength={teamNameLength}
        />
        <Field
          name="single_accounting_code"
          title={`کد تیم تنخواه‌داری`}
          component={SingleAccountingCode}
          typesWithTextField={[getTypeObjects()[0].type]}
          mainFieldType="select"
          change={data => {
            change(`single_accounting_code`, data);
          }}
          infoText={OTHER_SUB_ITEMS_ACCOUNTING_HINT}
        />
        {!isEdit && (
          <Field
            name="team_ids"
            component={TeamsSection}
            allAccessibleTeams={allAccessibleTeams}
          />
        )}
      </Box>
    </Modal>
  );
};

const mapStateToProps = store => {
  return {
    list: store.Team.list,
    data: store.Team.team,
    loading: store.Team.showLoading,
    showError: store.Team.showError,
    processing: store.Team.processing,
    modalData: store.Team.teamModalData,
    modalStatus: store.Team.teamModalStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    add: (projectId, data) => {
      dispatch(TeamAction.store(projectId, data));
    },
    edit: (id, data) => {
      dispatch(TeamAction.update(id, data));
    },
    closeModal: () => {
      dispatch(TeamAction.closeTeamModal());
    }
  };
};

const Index = reduxForm({
  form: "teamForm"
})(Form);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
